export default {
    "cancel": "電話",
    "vanAddressEditDetail": {
        "label": "荷受人の携帯電話番号",
        "placeholder": "荷受人の名前"
    },
    "save": "保存",
    "vanAddressList": {
        "add": "都道府県/市/地域を選択"
    },
    "delete": "保存",
    "telInvalid": "あなたの名前を入力してください",
    "tel": "電話",
    "telEmpty": "消去",
    "nameEmpty": "終了",
    "vanCoupon": {
        "unlimited": "プルダウンして更新..."
    },
    "lang": "中文",
    "vanCalendar": {
        "startEnd": "始める",
        "weekdays": "題名",
        "start": "消去してもよろしいですか",
        "title": "正しい電話番号を入力してください",
        "confirm": "終了",
        "end": "有効な名前を入力してください"
    },
    "vanSubmitBar": {
        "label": "次のページ"
    },
    "vanContactCard": {
        "addText": "始まりと終わり"
    },
    "loading": "キャンセル",
    "vanCascader": {
        "select": "確認"
    },
    "confirmDelete": "電話番号を入力してください",
    "vanContactList": {
        "addText": [
            "日",
            "一",
            "二",
            "三",
            "四",
            "五",
            "六"
        ]
    },
    "confirm": "名前を確認",
    "vanCouponCell": {
        "title": "リリースリフレッシュ...",
        "tips": "全て："
    },
    "vanPullRefresh": {
        "loosing": "前のページ",
        "pulling": "新しい連絡先"
    },
    "nameInvalid": "読み込んでいます...",
    "name": "名前",
    "vanPagination": {
        "next": "連絡先を追加",
        "prev": "選んでください"
    },
    "vanCouponList": {
        "empty": "使用制限なし",
        "enable": "クーポンなし",
        "disabled": "両替",
        "exchange": "クーポン",
        "placeholder": "クーポンなし",
        "close": "利用不可"
    },
    "vanAddressEdit": {
        "area": "使える",
        "namePlaceholder": "郵便番号の形式が正しくありません",
        "telPlaceholder": "詳細な住所を入力してください",
        "areaEmpty": "プロモーションコードを入力してください",
        "postalEmpty": "郵便番号",
        "addressEmpty": "範囲",
        "postal": "利用不可",
        "areaPlaceholder": "デフォルトの配送先住所として設定",
        "defaultAddress": "地域を選択"
    },
    "complete": "確認"
}